import { useCurrentUser } from "hooks/useCurrentUser";
import { useCallback, useEffect, useRef, useState } from "react";

// Create a hook to seperate out logic.
export const useHubspotChat = (portalId) => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const [activeConversation, setActiveConversation] = useState(false);
  const eventRef = useRef(null);
  const attachedRef = useRef(false);

  const { user } = useCurrentUser();

  useEffect(() => {
    if (!user) return;
    if (!user.hubspot_token) return;
    if (!hasLoaded) return;

    eventRef.current = (payload) => {
      setActiveConversation(payload.conversation.conversationId);
    };

    window.hsConversationsSettings = {
      identificationEmail: user?.email,
      identificationToken: user.hubspot_token,
    };

    window.HubSpotConversations.widget.load();
  }, [user, hasLoaded]);

  useEffect(() => {
    if (attachedRef.current) return;

    window.hsConversationsSettings = {
      loadImmediately: false,
    };

    // Add event listener.
    window.hsConversationsOnReady = [
      () => {
        setHasLoaded(true);
      },
    ];

    attachedRef.current = true;

    return () => {
      window.hsConversationsOnReady = [];
    };
  }, []);

  return {
    hasLoaded,
    activeConversation,
  };
};
